import React, { Component } from 'react';

import SideDrawer from '../components/Navigation/SideDrawer';
import ToolBar from '../components/Navigation/ToolBar';
import Backdrop from '../components/UI/Backdrop';
import Auxiliary from './Auxiliary';

class Layout extends Component {

    state = {
        sideDrawerOpen: false
    }

    sideDrawerOpenHandler = () => {
        this.setState(prevState => {
            return {
                sideDrawerOpen: true
            }
        })
    }

    sideDrawerCloseHandler = () => {
        this.setState(prevState => {
            return {
                sideDrawerOpen: false
            }
        })
    }

    render() {
        return (
            <Auxiliary>
                <ToolBar SideDrawerOpened={this.sideDrawerOpenHandler} />
                <Backdrop enable={this.state.sideDrawerOpen} clicked={this.sideDrawerCloseHandler} />
                <SideDrawer open={this.state.sideDrawerOpen} closed={this.sideDrawerCloseHandler} />
                <main>
                    {this.props.children}
                </main>
            </Auxiliary>
        );
    }
}

export default Layout;